import axios from '@/request/http.js'



//请求token
export const login = ({ login_name, password }) => {
  const data = {
    login_name,
    password
  }
  return axios.request({
    url: '/token',
    data,
    method: 'post'
  })
}

//获取用户信息
export const getUserInfo = () => {
  return axios.request({
    url: '/user/info',
    method: 'get',    
  })
}
